<template>
  <div class="logo" :class="[{ loaded: loaded }, cssClass]">
    <span></span>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: ["cssClass"],
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true
    }, 3300)
  },
  beforeDestroy() {
    clearTimeout()
  },
}
</script>

<style lang="sass" scoped>

@import "../../../assets/sass/variables"
.logo
  position: relative
  background: url("../../../assets/logos/animated_logo.png") no-repeat
  background-size: cover
  width: 100%
  height: 100%

  span
    position: absolute
    width: 100%
    height: 100%
    background-size: cover
    background-repeat: no-repeat
    transition: all .3s ease
    opacity: 0

.loaded
  span
    opacity: 1

@media only screen and (-webkit-device-pixel-ratio: 1.5)
  // modern browser do not support apng format
  .logo
    background-image: url("/static/animated_logo.webp")

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
  // MS IE 11
  .logo
    background-image: url("../../../assets/logos/animated_logo.gif")
    &.gray
      background-image: url("../../../assets/logos/animated_logo_gray.gif")

@supports (-ms-accelerator: true)
  // MS Edge
  .logo
    background-image: url("/static/animated_logo.webp")
</style>
